<h1>CIFRIS26 - Fourth National Conference</h1>
<div class="toptext">
	<p>
		CIFRIS26 is an international event promoted and organised by De Cifris together with Roma Tre University.<br><br>The event brings the cryptographic community together in a single place: researchers, practitioners, developers and users meet to share techniques, tools and ideas, and to build the connections from which new collaborations grow.
	</p>
	<p>
		The programme opens on the morning with a session devoted to institutional and industrial stakeholders working in cryptography and cyber security. The Scientific Session follows, dedicated to research talks, and the associated workshops close the day.
	</p>
	<p>
		The Scientific Session is made up of:
	</p>
	<ul>
		<!-- <li>One invited talk;</li> -->
		<li>A selection of contributed talks chosen by the Organizing Committee.</li>
	</ul>
</div>

<!-------------------------------------------------------------------->

<h2> INVITED SPEAKER </h2>

  <div class="text"  style="text-align:center;font-size: 20px;">
  	<!-- <b>Ludovic Perret</b> ( Sorbonne University & EPITA - France) -->
	 <b>Inserire SPEAKER</b>
</div>

<!-------------------------------------------------------------------->

<h2> ORGANIZATION </h2>
<div class="text">
	<h3> Institution </h3>
	<p>
		The “De Componendis Cifris Associazione di Promozione Sociale” (<a href="./">De Cifris</a>) is a non-profit
		scientific
		organization whose purpose is to spread cryptography in all its aspects, from theoretical foundations,
		applications to historical evolution and impact on society, and to facilitate the aggregation of scholars
		and researchers, so that from their collaboration project ideas and initiatives of scientific interest can
		rise.
	</p>

	<h3> Organizing Committee </h3>
	<!-- <ul>
		<li>
		        Laura Capuano (Roma Tre University - Italy)
		</li>
		<li>
		        Roberto Civino (University of L'Aquila - Italy)
		</li>
		<li>
			Francesco Romeo (University of Cassino and Southern Lazio - Italy)
		</li>
		<li>
			Giordano Santilli (National Cybersecurity Agency - Italy)
		</li>
	</ul>
	<b> Events Coordinator:</b> Elisa Cermignani (Athilab Srl - De Cifris) <br> <br> -->
	<b>Inserire Commissione Organizzatrice</b>
	For further information contact us at <a href="mailto:cifris26@decifris.it">cifris26<span>&#64;</span>decifris.it</a>
</div>
